import { createClient } from '@supabase/supabase-js';

// Создаем клиент Supabase только для работы со Storage
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Функция для получения списка аватарок из Storage
export async function getAvatarsList() {
  try {
    const { data, error } = await supabase
      .storage
      .from('avatars')
      .list('', {
        limit: 100,
        offset: 0
      });

    if (error) {
      console.error('Error loading avatars:', error);
      return [];
    }

    // Фильтруем только изображения
    const imageFiles = data?.filter((file: any) => 
      file.name && 
      (file.name.endsWith('.png') || 
       file.name.endsWith('.jpg') || 
       file.name.endsWith('.jpeg') ||
       file.name.endsWith('.webp'))
    ) || [];

    return imageFiles.map((file: any) => ({
      id: file.name.split('.')[0], // Используем имя файла без расширения как ID
      filename: file.name
    }));
  } catch (error) {
    console.error('Failed to get avatars list:', error);
    return [];
  }
}

// Функция для получения URL аватарки
export function getAvatarUrl(filename: string): string {
  const { data } = supabase
    .storage
    .from('avatars')
    .getPublicUrl(filename + '.png');
  
  return data.publicUrl;
}
